import { useCallback } from 'react'
import { harvestFarm } from 'utils/calls'
import { useCraftsman } from 'hooks/useContract'
import { DEFAULT_GAS_LIMIT } from 'config'

const useHarvestFarm = (farmPid: number) => {
  const craftsmanContract = useCraftsman()

  const handleHarvest = useCallback(async () => {
    await harvestFarm(craftsmanContract, farmPid, DEFAULT_GAS_LIMIT)
  }, [farmPid, craftsmanContract])

  return { onReward: handleHarvest }
}

export default useHarvestFarm
